import { loadableReady } from "@loadable/component";

import { Store, getMetadata, Tags, IglooManager } from "@inferno/renderer-shared-core";
import { ILog } from "@ihr-radioedit/inferno-core";

declare global {
  interface Window {
    __PRELOADED_STATE__: any;
  }
}

const log = ILog.logger("app/sites/amp-stats/index.tsx");

loadableReady(async () => {
  // Grab the state from a global variable injected into the server-generated HTML
  const preloadedState = window.__PRELOADED_STATE__;
  // Allow the passed state to be garbage-collected
  delete window.__PRELOADED_STATE__;

  log.debug("Preloaded State: ", preloadedState);

  const store = new Store(preloadedState);

  getMetadata({ store, isAmp: true });
  const tagState: Tags = store.tags;
  if (tagState.analytics?.view) {
    store.storeTags({
      ...tagState,
      analytics: {
        ...tagState.analytics,
        view: {
          ...tagState.analytics.view,
          contentFrame: "AMP",
        },
      },
    });
  }

  const igloo = new IglooManager(store);
  igloo.trackPageView();
});
